
import { mapActions } from 'vuex';
import AiInfo from './AiInfo';
import AiKeywordInfoDialog from './AiKeywordInfoDialog';

export default {
  i18nComponentKey: 'ReviewsNew.components.AiKeywords',
  name: 'AiKeywords',
  components: {
    AiInfo
  },
  props: {
    keywords: { type: Array, required: true },
    hasReward: { type: Boolean, required: true }
  },
  methods: {
    ...mapActions('bottomSheet', ['openBottomSheet']),
    onClickInfoButton() {
      this.openBottomSheet({
        component: AiKeywordInfoDialog
      });
    }
  }
};
